import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import { useNavigate } from "react-router-dom";
import "../ForgotPassword/ForgotPassword.css";
// Adjust the import based on your API structure
import Logo from "../../assets/images/Logo.png";
import { ForgotPasswords } from "../api/api";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/brown-background.jpg";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const response = await ForgotPasswords(values);
      console.log("Response received:", response);

      if (response?.success === true) {
        alert("Success: " + response?.msg);
        navigate("/Verification", { state: { values } });
      } else {
        alert(response.msg);
      }
    } catch (error) {
      alert("Error: Something went wrong.");
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="forgot-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="forgot-box">
        <img src={Logo} alt="Logo" className="login-logo" /> {/* Logo added */}
        <h2>Forgot Password</h2>
        <p className="forgot-text">
          Don't worry, it happens. Please enter your email, and we will send the
          OTP to it.
        </p>
        <Formik
          initialValues={{ email: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="forgot-form">
              <div className="form-group">
                {/* <label>Email</label> */}
                <Field
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="Enter your email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error-message"
                />
              </div>

              <button
                type="submit"
                className="forgot-button"
                disabled={isLoading || isSubmitting}
              >
                {isLoading ? "Sending..." : "Continue"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ForgotPassword;
